import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AuthStore } from '../authentication/authStore';
import { SsrBrowserContextService } from '../context/ssrBrowserContextService';
import { UsertStore } from '../context/userStore';

export function authInitializer() {
  return async () => {
    if (inject(SsrBrowserContextService).isBrowser) {
      const auth = inject(AuthStore);
      const userStore = inject(UsertStore);
      await auth.init();
      //await userStore.ready();
    }
    return;
  };
}
